<div style="margin-top: 50px" fxLayout="column" fxLayoutAlign="center center" *ngIf="!patientNotes">
  <mat-spinner></mat-spinner>
</div>

<form *ngIf="patientNotes" [formGroup]="actionItemFormGroup" novalidate autocomplete="off">
  <app-mat-simple-select
    [label]="fieldLabels['incomingAnsweredNoteId']"
    name="incomingAnsweredNoteId"
    placeholder="Note"
    [selectItems]="patientNotes"
    formControlName="incomingAnsweredNoteId"
  ></app-mat-simple-select>

  <app-mat-simple-select
    [label]="fieldLabels['incomingMissedNoteId']"
    name="incomingMissedNoteId"
    placeholder="Note"
    [selectItems]="patientNotes"
    formControlName="incomingMissedNoteId"
  ></app-mat-simple-select>

  <app-mat-simple-select
    [label]="fieldLabels['incomingMailboxNoteId']"
    name="incomingMailboxNoteId"
    placeholder="Note"
    [selectItems]="patientNotes"
    formControlName="incomingMailboxNoteId"
  ></app-mat-simple-select>

  <app-mat-simple-select
    [label]="fieldLabels['outgoingAnsweredNoteId']"
    name="outgoingAnsweredNoteId"
    placeholder="Note"
    [selectItems]="patientNotes"
    formControlName="outgoingAnsweredNoteId"
  ></app-mat-simple-select>

  <app-mat-simple-select
    [label]="fieldLabels['outgoingMissedNoteId']"
    name="outgoingMissedNoteId"
    placeholder="Note"
    [selectItems]="patientNotes"
    formControlName="outgoingMissedNoteId"
  ></app-mat-simple-select>

  <app-hha-note-template [noteFormControl]="templateNoteFormControl"></app-hha-note-template>
</form>
